import { DropdownMenu as RM } from 'radix-ui';
import type { ComponentType, ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** `icon` is a lucide component; `leading` is anything else that should sit before the label, such as a project's colour dot. */
export type MenuItem = { label: string; icon?: ComponentType<{ size?: number }>; leading?: ReactNode; onSelect: () => void; danger?: boolean; disabled?: boolean; separatorBefore?: boolean };

/** Row-action menu (the `···`). Radix DropdownMenu: keyboard nav, typeahead, portal. */
export function Menu({ trigger, items, align = 'end' }: { trigger: ReactNode; items: MenuItem[]; align?: 'start' | 'end' }) {
  return (
    <RM.Root>
      <RM.Trigger asChild>{trigger}</RM.Trigger>
      <RM.Portal>
        <RM.Content align={align} sideOffset={4} className="z-50 min-w-[180px] rounded-card-sm border border-border bg-card shadow-float p-1">
          {items.map((it) => (
            <div key={it.label}>
              {it.separatorBefore && <RM.Separator className="h-px my-1 bg-row-divider" />}
              <RM.Item disabled={it.disabled} onSelect={it.onSelect}
                className={cn('flex items-center gap-2 h-8 px-2 rounded-input text-row-title cursor-pointer outline-none select-none data-[highlighted]:bg-inset data-[disabled]:opacity-50',
                  it.danger ? 'text-danger-fg' : 'text-ink')}>
                {it.icon && <it.icon size={14} />}{it.leading}{it.label}
              </RM.Item>
            </div>
          ))}
        </RM.Content>
      </RM.Portal>
    </RM.Root>
  );
}
